document.addEventListener('DOMContentLoaded', () => {
  const $root = $('.affiliate-page')

  if (!$root.length) {
    return
  }

  // -----  Mass payouts -----

  payAllButton = $('.affiliate-payouts__masspay-button')

  togglePayAllButton = function () {
    checked_chekboxes = $('.affiliate-payouts__pay-checkbox:checked').length

    payAllButton.toggleClass('affiliate-payouts__masspay-button', checked_chekboxes >= 1)
    payAllButton.toggleClass('affiliate-payouts__masspay-button-disabled', checked_chekboxes < 1)
  }

  checkboxes = $root.find('.affiliate-payouts__pay-checkbox')
  checkboxes.each(function () {
    cbox = $(this)
    is_payout_already_paid = cbox.closest('tr').find('.affiliate-payouts__status').html() == 'Paid'
    if (is_payout_already_paid) {
      // Disable checkbox
      cbox.attr('disabled', true)
    }
  })

  // Listen 'Select all' checkbox changes
  $('.affiliate-payouts__pay-checkbox-payall').change(function () {
    if (this.checked == true) {
      checkboxes.each(function () {
        if (this.disabled == false) {
          this.checked = true
        }
      })
    } else {
      checkboxes.each(function () {
        this.checked = false
      })
    }

    togglePayAllButton()
  })

  // Lisyten click on single checkbox
  $('.affiliate-payouts__pay-checkbox').change(function () {
    togglePayAllButton()
  })

  // Listen 'Pay All' button click
  payAllButton.click(function (event) {
    event.preventDefault()
    checked_checkboxes = $('.affiliate-payouts__pay-checkbox:checked')
    payout_ids = checked_checkboxes
      .map(function () {
        return this.value
      })
      .get()

    params = {
      body: JSON.stringify({ payouts_ids: payout_ids }),
      method: 'PUT',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
    }

    pathArray = window.location.pathname.split('/')
    url = '/admin/affiliates/' + pathArray[pathArray.length - 1] + '/pay_multiple'

    fetch(url, params).then(() => {
      window.location.reload()
    })
  })
})
